document.querySelectorAll('[data-accordion]').forEach(accordion => {
  const trigger = accordion.querySelector('.accordion-trigger');
  const content = accordion.querySelector('.accordion__content');
  const inner = accordion.querySelector('.accordion__content-inner');

  trigger.addEventListener('click', () => {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', !isExpanded);
    
    if (!isExpanded) {
      content.style.setProperty('--content-height', inner.offsetHeight + 'px');
    } else {
      content.style.setProperty('--content-height', '0px');
    }
  });
});